/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2023-02-03 09:37:38
 * @Description: 
 */
import clsx from "clsx";
import React from "react";
import FTAnalytic from "src/analyze/FTAnalytic";
import { IconArrawDown } from "src/assets";
import { useCurrentEffect } from "src/hooks";
import FTImageStore from "src/store/FTImageStore";
import EffectListCollapseItem from "../EffectListCollapseItem/EffectListCollapseItem"
import "./EffectListCollapse.scss"
interface Iprops {
  effectList: any[];
  title: string;
  isCollapse: boolean;
  needCollapse?: boolean;
}
export default function EffectListCollapse(props: Iprops) {
  let { effectList, title, isCollapse, needCollapse = true } = props
  let newEffectList = []
  let currentEffect = useCurrentEffect()
  const handleClick = () => {
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$click_up$goart_project_effects',
      label: {
        resource_id: title,
        resource_name: title,
      }
    })
    FTImageStore.effectClassifyMap = FTImageStore.effectClassifyMap.map((item: any) => {
      if(item.title === title) {
        item.collapse = !item.collapse
      }
      return item
    })
  }

  for(let i = 0; i < effectList.length; i += 3) {
    newEffectList.push(effectList.slice(i, i + 3))
  }
  return <div className="effect_collapse" id={title}>
    {needCollapse ? <div className={clsx(isCollapse && "effect_collapse_title_collapse", "effect_collapse_title")} onClick={handleClick}>
      { title }
      <IconArrawDown />
    </div> : <div className="effect_collapse_title1">
      { title }
    </div>}
    <div className="effect_collapse_list" style={{
      display: !isCollapse ? "none" : "flex"
    }}>
      {
        newEffectList.map((item, index) => {
          return <div key={title + index}>
            {
              item.map(ite => {
                return <EffectListCollapseItem needCollapse={needCollapse} key={ite.name} effect={ite} active={currentEffect === ite} />
              })
            }
          </div>
        })
      }
    </div>
  </div>
}